import { render, staticRenderFns } from "./DeParaCompetencia.vue?vue&type=template&id=44961b40&"
import script from "./DeParaCompetencia.vue?vue&type=script&lang=js&"
export * from "./DeParaCompetencia.vue?vue&type=script&lang=js&"
import style0 from "./DeParaCompetencia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports